// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RSt7","title":"styles_title__1uPpg"};